import { useCallback, useState } from "react";
import {
  EContractType,
  ESenderRole,
  IContractDetailsResponseData,
} from "../../../../../setup/api/services/contract/models";
import { AuthConfig } from "../../../../../setup/context/config/authConfig";
import { EContractActions } from "../../../../../setup/api/services/contractActions/enum";
import { externalDoAction } from "../../../../../setup/api/services/contractActions";
import PrimaryButton from "../../../../../components/common/PrimaryButton";
import Spinner from "../../../../../components/common/Spinner";
import { useTranslation } from "react-i18next";
import OutlinedButton from "../../../../../components/common/OutlinedButton";

interface WaitingForDeliveryActionsProps {
  milestone: IContractDetailsResponseData;
}

const WaitingForDeliveryActions = ({
  milestone,
}: WaitingForDeliveryActionsProps) => {
  const { t } = useTranslation();
  const userInfo = AuthConfig.getUserInfo();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);

  const handleConfirmDelivery = useCallback(async () => {
    setConfirmLoading(true);
    const body = {
      contractId: milestone?.id,
      userId: userInfo?.userIdentification || "",
      actorRole: ESenderRole.CLIENT_ADMIN,
      contractAction: EContractActions.ACCEPT_CONTRACT,
      contractType: EContractType.MILESTONE_CONTRACT,
    };
    await externalDoAction(body);
    setConfirmLoading(false);
    window.location.reload();
  }, [milestone?.id, userInfo?.userIdentification]);

  const handleRejectDelivery = useCallback(async () => {
    setRejectLoading(true);
    const body = {
      contractId: milestone?.id,
      userId: userInfo?.userIdentification || "",
      actorRole: ESenderRole.CLIENT_ADMIN,
      contractAction: EContractActions.REJECT_CONTRACT,
      contractType: EContractType.MILESTONE_CONTRACT,
    };
    await externalDoAction(body);
    setRejectLoading(false);
    window.location.reload();
  }, [milestone?.id, userInfo?.userIdentification]);

  return (
    <>
      <OutlinedButton
        disabled={rejectLoading}
        onClick={handleRejectDelivery}
        style={{
          width: "180px",
          color: "#E32A34",
          background: rejectLoading ? "#E2E5EE" : "#FFF5F5",
          border: "none",
          fontSize: "14px",
          fontWeight: 500,
          height: "40px",
        }}>
        {rejectLoading ? <Spinner /> : t("lbl_reject")}
      </OutlinedButton>
      <PrimaryButton
        disabled={confirmLoading}
        onClick={handleConfirmDelivery}
        style={{
          width: "180px",
          height: "40px",
          borderRadius: "8px",
          textAlign: "center",
          whiteSpace: "nowrap",
          fontSize: "14px",
          lineHeight: "100%",
          fontWeight: 500,
          background: confirmLoading ? "#E2E5EE" : "#0D44AD",
        }}>
        {confirmLoading ? <Spinner /> : t("lbl_confirm_delivery")}
      </PrimaryButton>
    </>
  );
};

export default WaitingForDeliveryActions;
